export default __webpack_public_path__ + "static/dont-focus-after-motion-33fe220141b862da1682b1c93a319440b7ccb6b44e0f21e4e0b359e9a80f5bd8.png";